export default {
    endPoints: {}
}
export * from './PartPayment';
export * from './Actions';